import React from 'react'
import { HomeRails } from '../home-rails'
import { HomeContentCard } from '../home-content-card'
import { HOME_SECTION_TYPE } from './home-sections'

export const WhatsNewRails = ({ whatsNewSection }) => {
  const { items } = whatsNewSection

  return (
    <HomeRails
      title="What's New"
      items={items}
      dataTest='home-whats-new-rails'
      renderItem={(item, itemIndex) => {
        return (
          <HomeContentCard
            content={item}
            dataTest={`home-whats-new-${itemIndex}`}
            itemIndex={itemIndex}
            railType={HOME_SECTION_TYPE.WHATS_NEW}
          />
        )
      }}
    />
  )
}
